import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";

const EnvironmentBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (import.meta.env.VITE_ENVIRONMENT !== "development" || dismissed) {
    return null;
  }

  return (
    <div className="relative z-20 flex items-center justify-between gap-3 bg-amber-50 border-b border-amber-200 px-4 py-2 text-sm text-amber-800 sm:px-6">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          Environnement de développement — Les données sont synchronisées depuis
          la production chaque nuit.
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 rounded p-0.5 hover:bg-amber-200/50 transition-colors"
        aria-label="Fermer"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default EnvironmentBanner;
